import classnames from "classnames";

import useDispensaryUpdates from "hooks/useDispensaryUpdates";

import DispensaryUpdate from "components/Dispensary/DispensaryUpdate";

const Updates: React.FC<{ className?: string }> = ({ className }) => {
  const { updates, inViewRef } = useDispensaryUpdates();

  return (
    <div className={classnames(className)} ref={inViewRef}>
      {updates.length ? (
        <>
          <div className="section__header">
            <h3 className="heading--m">Updates</h3>
          </div>
          <div className="row">
            {updates.map((u, i) => (
              <div className="lg:col-4 mb-lg" key={i}>
                <DispensaryUpdate
                  update={u}
                  className="bg-leafly-white h-full"
                />
              </div>
            ))}
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Updates;
